import { PERCENT } from 'constants/promotions';
import { HonestPricingLawServiceFeeTypes } from 'base-ordering/constants/HonestPricingLaw';

export const getHonestLawCustomFeeText = (
  bannerText,
  chargeCustomFee,
  chargeServiceFee,
  feeType,
  customFeeName,
  customFeeAmount,
  customFeeFlatOrPercent
) => {
  if (chargeCustomFee) {
    const amount =
      customFeeFlatOrPercent === PERCENT
        ? `${parseInt(customFeeAmount)}%`
        : `$${customFeeAmount}`;

    if (chargeServiceFee) {
      bannerText = `${bannerText}, along with an additional ${customFeeName} fee of ${amount}`;
    } else {
      if (feeType === HonestPricingLawServiceFeeTypes.CATERING_ORDER) {
        bannerText = `A ${customFeeName} fee of ${amount} will be applied to your order`;
      } else {
        bannerText = `A one-time ${customFeeName} fee of ${amount} will be applied to your order`;
      }
    }
  }
  return `${bannerText}.`;
};
